<template>
    <b-card :header="uLang('app.most_recent_started_trajectory')" header-tag="h4" class="latest-trajectory bg-default-card">
        <rea-loader :loading="loading"></rea-loader>
        <table class="latest-traject-table table">
            <tr>
                <td width="150">{{ uLang('app.name') }}:</td>
                <td>
                    {{ $getIfExists(cardData, 'trajectory.name', uLang('app.no_name')) }}
                </td>
            </tr>
            <tr>
                <td>{{ uLang('app.description') }}:</td>
                <td>{{ cardData.trajectory.description === null ? uLang('app.no_description') : cardData.trajectory.description }}</td>
            </tr>
            <tr v-if="cardData.trajectory_manager">
                <td>{{ uLang('app.coach') }}:</td>
                <td>{{ cardData.trajectory_manager.full_name }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.start_date') }}:</td>
                <td>{{ typeof cardData.trajectory_start_date === null ? uLang('app.no_start_date') : $options.filters.date(cardData.trajectory_start_date) }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.end_date') }}:</td>
                <td>{{ typeof cardData.trajectory_end_date === null ? uLang('app.no_end_date') : $options.filters.date(cardData.trajectory_end_date) }}</td>
            </tr>
        </table>
    </b-card>
</template>
<script>
import { ReaLoader } from '~/components/helpers'
export default {
    name: 'LatestTraject',

    components: {
        ReaLoader
    },

    props: {
        trajectoryData: {
            required: true,
        },
        loading: {
            required: true,
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            emptyPanel: {
                'trajectory': {
                    'name': uLang('app.no_trajectory'),
                    'description': uLang('app.no_description'),
                },
                'reporting_person': {
                    'full_name': uLang('app.no_coach'),
                },
                'trajectory_start_date': null,
                'trajectory_end_date': null,
            },
        }
    },

    methods: {

    },

    computed: {
        cardData: function() {
            if(_.isEmpty(this.trajectoryData)) {
                return this.emptyPanel
            }

            return this.trajectoryData
        }
    }
}
</script>
<style lang="scss">
    table.latest-traject-table {
        tr:first-child {
            td {
                text-align: left;
                border-top: none;
            }
        }
        td {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
    }
</style>
